import { Settings } from '@/config'
import { GiphyFetch } from '@giphy/js-fetch-api'

export const giphyClient = new GiphyFetch(Settings.ApiCredentials.Gyphi.ApiKey)
